"use strict";

exports.__esModule = true;
exports.default = exports.virtualListPropTypes = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Listbox = _interopRequireDefault(require("react-widgets/lib/Listbox"));
var _reactList = _interopRequireDefault(require("react-list"));
var _ListOption = _interopRequireDefault(require("react-widgets/lib/ListOption"));
var _ListOptionGroup = _interopRequireDefault(require("react-widgets/lib/ListOptionGroup"));
var _ = require("react-widgets/lib/util/_");
var CustomPropTypes = _interopRequireWildcard(require("react-widgets/lib/util/PropTypes"));
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var virtualListPropTypes = {
  itemSizeEstimator: _propTypes.default.func,
  itemSizeGetter: _propTypes.default.func,
  pageSize: _propTypes.default.number,
  threshold: _propTypes.default.number,
  type: _propTypes.default.oneOf(['simple', 'variable', 'uniform']),
  useStaticSize: _propTypes.default.bool,
  useTranslate3d: _propTypes.default.bool,
  hasNextPage: _propTypes.default.bool,
  onRequestItems: _propTypes.default.func,
  loadingComponent: CustomPropTypes.elementType
};
exports.virtualListPropTypes = virtualListPropTypes;
var VirtualList = /*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(VirtualList, _React$Component);
  function VirtualList() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this._renderItem = function (_ref) {
      var item = _ref.item,
        rest = _objectWithoutProperties(_ref, ["item"]);
      var _this$props = _this.props,
        isDisabled = _this$props.isDisabled,
        renderItem = _this$props.renderItem,
        textAccessor = _this$props.textAccessor,
        valueAccessor = _this$props.valueAccessor;
      var Component = _this.props.itemComponent;
      if (renderItem) {
        return renderItem(_extends({
          item: item
        }, rest));
      } else if (Component) {
        return _react.default.createElement(Component, _extends({
          item: item,
          value: valueAccessor(item),
          text: textAccessor(item),
          disabled: isDisabled(item)
        }, rest));
      }
      return textAccessor(item);
    };
    _this._renderGroup = function (group, searchTerm) {
      var _this$props2 = _this.props,
        renderGroup = _this$props2.renderGroup,
        Component = _this$props2.groupComponent;
      if (renderGroup) {
        return renderGroup({
          group: group,
          searchTerm: searchTerm
        });
      } else if (Component) {
        return _react.default.createElement(Component, {
          item: group,
          searchTerm: searchTerm
        });
      }
      return group;
    };
    _this.renderItems = function (items, ref) {
      var _this$props3 = _this.props,
        className = _this$props3.className,
        messages = _this$props3.messages;
      return _react.default.createElement(_Listbox.default, {
        nodeRef: ref,
        className: (0, _classnames.default)(className, 'rw-virtual-list'),
        emptyListMessage: messages.emptyList(_this.props)
      }, items);
    };
    _this.renderItem = function (index, key) {
      var _this$props4 = _this.props,
        activeId = _this$props4.activeId,
        focusedItem = _this$props4.focusedItem,
        selectedItem = _this$props4.selectedItem,
        onSelect = _this$props4.onSelect,
        dataState = _this$props4.dataState,
        isDisabled = _this$props4.isDisabled,
        pageSize = _this$props4.pageSize,
        hasNextPage = _this$props4.hasNextPage,
        onRequestItems = _this$props4.onRequestItems,
        searchTerm = _this$props4.searchTerm,
        LoadingComponent = _this$props4.loadingComponent,
        OptionComponent = _this$props4.optionComponent;
      var item = dataState.flatData[index];
      var len = dataState.flatData.length;
      if (hasNextPage === true && index >= len) {
        if (onRequestItems) onRequestItems({
          pageSize: pageSize,
          searchTerm: searchTerm,
          limit: len + pageSize,
          currentIndex: index
        });
        return _react.default.createElement("li", {
          key: key,
          className: "rw-list-empty rw-list-option-loading"
        }, LoadingComponent ? _react.default.createElement(LoadingComponent, {
          key: key,
          index: index,
          pageSize: pageSize
        }) : 'Loading items…');
      }
      if (item && item.__isGroup) {
        return _react.default.createElement(_ListOptionGroup.default, {
          key: key
        }, _this._renderGroup({
          group: item.group,
          searchTerm: searchTerm
        }));
      }
      var isFocused = focusedItem === item;
      return _react.default.createElement(OptionComponent, {
        key: key,
        activeId: activeId,
        dataItem: item,
        focused: isFocused,
        disabled: isDisabled(item),
        selected: selectedItem === item,
        onSelect: onSelect
      }, _this._renderItem({
        item: item,
        index: index,
        searchTerm: searchTerm
      }));
    };
    return _this;
  }
  VirtualList.getVirtualListProps = function getVirtualListProps(_ref2) {
    var type = _ref2.type,
      itemSizeGetter = _ref2.itemSizeGetter,
      itemSizeEstimator = _ref2.itemSizeEstimator,
      _ref2$pageSize = _ref2.pageSize,
      pageSize = _ref2$pageSize === void 0 ? 20 : _ref2$pageSize,
      _ref2$threshold = _ref2.threshold,
      threshold = _ref2$threshold === void 0 ? 300 : _ref2$threshold,
      useStaticSize = _ref2.useStaticSize,
      useTranslate3d = _ref2.useTranslate3d,
      onRequestItems = _ref2.onRequestItems,
      hasNextPage = _ref2.hasNextPage,
      loadingComponent = _ref2.loadingComponent,
      props = _objectWithoutProperties(_ref2, ["type", "itemSizeGetter", "itemSizeEstimator", "pageSize", "threshold", "useStaticSize", "useTranslate3d", "onRequestItems", "hasNextPage", "loadingComponent"]);
    return {
      props: props,
      listProps: {
        onRequestItems: onRequestItems,
        hasNextPage: hasNextPage,
        loadingComponent: loadingComponent,
        type: type,
        itemSizeGetter: itemSizeGetter,
        itemSizeEstimator: itemSizeEstimator,
        pageSize: pageSize,
        threshold: threshold,
        useStaticSize: useStaticSize,
        useTranslate3d: useTranslate3d
      }
    };
  };
  VirtualList.getDataState = function getDataState(data, _ref3, lastState) {
    var groupBy = _ref3.groupBy;
    var initial = {
      flatData: data
    };
    lastState = lastState || initial;
    if (lastState.data !== data || lastState.groupBy !== groupBy) {
      if (!groupBy) return initial;
      var keys = [];
      var groups = (0, _.groupBySortedKeys)(groupBy, data, keys);
      var sequentialData = [];
      var flatData = [];
      keys.forEach(function (group) {
        var items = groups[group];
        var groupItem = {
          __isGroup: true,
          group: group
        };
        sequentialData = sequentialData.concat(items);
        flatData = flatData.concat([groupItem], items);
      }, []);
      return {
        groups: groups,
        groupBy: groupBy,
        flatData: flatData,
        sequentialData: sequentialData,
        sortedKeys: keys
      };
    }
    return lastState;
  };
  var _proto = VirtualList.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.move();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props5 = this.props,
      valueAccessor = _this$props5.valueAccessor,
      focusedItem = _this$props5.focusedItem,
      selectedItem = _this$props5.selectedItem;
    if (valueAccessor(prevProps.focusedItem) !== valueAccessor(focusedItem) || valueAccessor(prevProps.selectedItem) !== valueAccessor(selectedItem)) this.move();
  };
  _proto.render = function render() {
    var _this$props6 = this.props,
      type = _this$props6.type,
      itemSizeGetter = _this$props6.itemSizeGetter,
      itemSizeEstimator = _this$props6.itemSizeEstimator,
      pageSize = _this$props6.pageSize,
      threshold = _this$props6.threshold,
      useStaticSize = _this$props6.useStaticSize,
      _this$props6$useTrans = _this$props6.useTranslate3d,
      useTranslate3d = _this$props6$useTrans === void 0 ? true : _this$props6$useTrans,
      dataState = _this$props6.dataState,
      itemHeight = _this$props6.itemHeight,
      focusedItem = _this$props6.focusedItem,
      selectedItem = _this$props6.selectedItem,
      onSelect = _this$props6.onSelect,
      hasNextPage = _this$props6.hasNextPage,
      searchTerm = _this$props6.searchTerm,
      disabled = _this$props6.disabled;
    var length = dataState.flatData.length;
    if (hasNextPage === true) length += 1;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)('rw-virtual-list-wrapper', type === 'uniform' && 'rw-virtual-list-fixed')
    }, _react.default.createElement(_reactList.default, {
      ref: "scrollable",
      type: type,
      length: length,
      pageSize: pageSize,
      threshold: threshold,
      useStaticSize: useStaticSize,
      useTranslate3d: useTranslate3d,
      itemRenderer: this.renderItem,
      itemsRenderer: this.renderItems,
      itemSizeGetter: itemSizeGetter,
      itemSizeEstimator: itemSizeEstimator // these are all to break the list's SCU
      ,

      dataState: dataState,
      focusedItem: focusedItem,
      selectedItem: selectedItem,
      searchTerm: searchTerm,
      onSelect: onSelect,
      disabled: disabled,
      itemHeight: itemHeight
    }));
  };
  _proto.move = function move() {
    var _this$props7 = this.props,
      dataState = _this$props7.dataState,
      focusedItem = _this$props7.focusedItem;
    var scrollable = this.refs.scrollable;
    var idx = dataState.flatData.indexOf(focusedItem);
    if (idx === -1) return;
    scrollable.scrollAround(idx);
  };
  return VirtualList;
}(_react.default.Component);
VirtualList.propTypes = _extends({}, virtualListPropTypes, {
  data: _propTypes.default.array,
  dataState: _propTypes.default.object,
  onSelect: _propTypes.default.func,
  onMove: _propTypes.default.func,
  activeId: _propTypes.default.string,
  optionComponent: CustomPropTypes.elementType,
  renderItem: _propTypes.default.func,
  renderGroup: _propTypes.default.func,
  focusedItem: _propTypes.default.any,
  selectedItem: _propTypes.default.any,
  isDisabled: _propTypes.default.func.isRequired,
  valueAccessor: _propTypes.default.func.isRequired,
  textAccessor: _propTypes.default.func.isRequired,
  disabled: CustomPropTypes.disabled.acceptsArray,
  messages: _propTypes.default.shape({
    emptyList: CustomPropTypes.message
  })
});
VirtualList.defaultProps = {
  optionComponent: _ListOption.default,
  type: 'variable',
  hasNextPage: false
};
var _default = VirtualList;
exports.default = _default;